import { render, staticRenderFns } from "./DobComponent.vue?vue&type=template&id=421b3e5c"
import script from "./DobComponent.vue?vue&type=script&lang=js"
export * from "./DobComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports